import { get, post, put, del } from "aws-amplify/api";
import { deriveStateCodeFromPostcode } from "utils/slmValidations";

import "containers/common/Detail.css";
import SLMAgentAgencyPanel from "containers/slm/shared/SLMAgentAgencyPanel";
import SLMOwnerPartyPanel from "containers/slm/shared/SLMOwnerPartyPanel";
import SLMReferencesPanel from "containers/slm/shared/SLMReferencesPanel";
import SLMPropertyIntegrationsList from "containers/slm/shared/SLMPropertyIntegrationsList";
import SLMPropertyIntegrationsModal from "containers/slm/shared/SLMPropertyIntegrationsModal";
import SLMTitleDetailsList from "containers/slm/shared/SLMTitleDetailsList";
import SLMTitleDetailsModal from "containers/slm/shared/SLMTitleDetailsModal";
import SLMVolumeFoliosList from "containers/slm/shared/SLMVolumeFoliosList";
import SLMVolumeFoliosModal from "containers/slm/shared/SLMVolumeFoliosModal";
import SLMSpaceInformationPanel from "containers/slm/lease/panels/SLMSpaceInformationPanel";
import SLMLeaseInformationPanel from "containers/slm/lease/panels/SLMLeaseInformationPanel";
import SLMRecordDeliverPanel from "containers/slm/shared/SLMRecordDeliverPanel";
import SLMHistoryPanel from "containers/slm/shared/SLMHistoryPanel";

import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Button, Col, Form, Row, Modal, Alert, Nav } from "react-bootstrap";
import { PacmanLoader } from "react-spinners";
import "react-datepicker/dist/react-datepicker.css";
import { createElementIdFactory } from "utils/elementIds";
import { readStoredBrowseIds, storeBrowseIds } from "utils/browseIdSession";
import SLMPropertyAddressPanel from "containers/slm/shared/SLMPropertyAddressPanel";
import SLMBrowsePager from "containers/slm/shared/SLMBrowsePager";


const goLive = new Date("09 May 2023");

// Seeded onto every new lease so validateRelatedRecord passes; the matching selected*
// objects must be seeded too or the dropdown renders blank while the id is already set.
const NEW_LEASE_DEFAULT_LEASE_STATUS = { value: 283, label: "Existing" };
const NEW_LEASE_DEFAULT_SPACE_USE = { value: 250, label: "SPACE TYPE UNKOWN" };
const NEW_LEASE_DEFAULT_QUALITY_TYPE = { value: 2, label: "Prime" };

// rent_per_annum is stored as a Postgres integer, unlike rent/tenant_area which are floats,
// so their product can overflow the column and fail the UPDATE.
const PG_MAX_INT = 2147483647;
const exceedsIntegerColumn = (value) => Number.isFinite(Number(value)) && Math.abs(Number(value)) > PG_MAX_INT;

// Narrow varchar widths in aslm4.lease; exceeding one fails the UPDATE with a raw SQL error.
const LEASE_TEXT_COLUMN_LIMITS = [
  ["options", 5, "Options text"],
  ["lease_level", 14, "Suite/level"],
  ["unit_number", 5, "Unit number"],
  ["source_page_1", 3, "Reference 1 page"],
  ["source_page_2", 3, "Reference 2 page"],
  ["source_page_3", 3, "Reference 3 page"],
];

export default function SLMLeaseDetail(props) {
  const routeLocation = useLocation();
  const routeNavigate = useNavigate();
  const routeParams = useParams();
  const createIdFactory = useMemo(() => createElementIdFactory("slm-lease-detail"), []);
  const initialPath = routeLocation?.pathname ?? props?.location?.pathname ?? "";
  const initialPathMatch = initialPath.match(/\/slmleases\/([^/?#]+)/i);
  const initialLeaseIdParam = routeParams?.id ?? props?.match?.params?.id ?? props?.params?.id ?? (initialPathMatch ? decodeURIComponent(initialPathMatch[1]) : null);
  const parsedInitialLeaseId = Number.parseInt(initialLeaseIdParam, 10);
  const initialLeaseId = Number.isNaN(parsedInitialLeaseId) ? null : parsedInitialLeaseId;

  const [state, setStateInternal] = useState({
      titleDetailsSaved: false,
      volumeFoliosSaved: false,

      isLoading: null,
      isDeleting: null,
      lease: null,
      modified: false,
      showAlert: false,
      errorMessage: "",

      idList: [],

      addressFilter: { addressid: -1 },
      agencyFilter: { leaseid: initialLeaseId, saleid: null, agentname: null },
      ownerFilter: { leaseid: initialLeaseId, saleid: null, ownername: null },

      selectedSourceCategories1: null,
      selectedSourceCategories2: null,
      selectedSourceCategories3: null,
      selectedLeaseStatusCategories: null,
      selectedSpaceUseCategories: null,
      selectedBroadSpaceUseCategories: null,
      selectedQualityTypeCategories: null,
      selectedLeaseMethodCategories: null,
      selectedLevelCategories: null,
      selectedCarSpaceCategories: null,
      selectedOutgoingsCategories: null,
      selectedRentBasisCategories: null,
      selectedReviewBasisCategories: null,
      selectedRentPerAnnumBasisCategories: null,

      selectedSuburb: null,
      suburbOptions: [],
      entityLinks: [], //new
      ownerLinks: [], //new
      agencyOptions: [],
      agents: [], //new

      showAgencyDialog: false, //new
      saveForm: false, //new

      lease_id: null,

      hard_sequence: null,
      address_id: null,
      address_hard_sequence: null,
      building_name: null,
      floor_unit: null,
      street_no_low: null,
      street_no_high: null,
      street_name: null,
      extension: null,
      suburb: null,
      postcode: null,
      state_code: null,
      street_address_full: null,
      source_cat_id: null,
      source_cat: null,
      source_date: null,
      source_page: null,
      source_cat_1_id: null,
      source_cat_1: null,
      source_date_1: null,
      source_page_1: null,
      source_cat_2_id: null,
      source_cat_2: null,
      source_date_2: null,
      source_page_2: null,
      source_cat_3_id: null,
      source_cat_3: null,
      source_date_3: null,
      source_page_3: null,
      lease_commence_date: null,
      rent: null,
      rent_basis: null,
      asking_rent: null,
      space_use_id: null,
      space_use_code: null,
      space_use_name: null,
      broad_space_use_id: null,
      broad_space_use_code: null,
      quality_type_id: null,
      quality_type: null,
      term: null,
      options: null,
      outgoings: null,
      lease_basis: null,
      rent_basis_cat: null,
      tenant_area: null,
      lease_level: null,
      cars: null,
      car_rate: null,
      lease_type: null,
      lease_type_cat_id: null,
      lease_type_cat: null,
      level_description_cat_id: null,
      level_description_cat: null,
      rent_per_annum: null,
      rent_per_annum_basis_cat_id: null,
      rent_per_annum_basis_cat: null,
      outgoing_basis_cat_id: null,
      outgoing_basis_cat: null,
      lease_basis_cat_id: null,
      lease_basis_cat: null,
      lease_status_cat_id: null,
      lease_status_cat: null,
      car_space_descr_cat_id: null,
      car_space_descr_cat: null,
      lessee: null,
      owner: null,
      agent: null,
      agency: null,
      pending: null,
      estimated: null,
      review: null,
      print_month: null,
      prev_delivery: null,
      stat_date: null,
      editors_note: null,
      note_data: null,
      lease_notes: null,
      lease_notes_computed: null,
      created_date: null,
      created_by: null,
      last_edited_date: null,
      last_edited_by: null,
      archived_date: null,
      unit_number: null,

      titleDetails: [],
      showTitleDetailsDialog: false,

      volumeFolios: [],
      showVolumeFoliosDialog: false,

      integrations: [],
        showAddressMatchingDialog: false,

      title_details: null,
  });

  const stateRef = useRef(state);
  useEffect(() => {
    stateRef.current = state;
  }, [state]);

  // Guards against a stale in-flight load (e.g. from the previous record) applying its
  // results after a newer navigation (such as clicking "New Lease") has already reset the form.
  const loadRequestIdRef = useRef(0);

  const setState = useCallback((updater, callback) => {
    // stateRef must advance synchronously: save/route logic reads it immediately after setState.
    const nextPartial = typeof updater === "function" ? updater(stateRef.current) : updater;
    const next = { ...stateRef.current, ...(nextPartial || {}) };
    stateRef.current = next;
    setStateInternal(next);

    if (typeof callback === "function") {
      setTimeout(callback, 0);
    }
  }, []);

  const [addressRecordId, setAddressRecordId] = useState(null);
  const [addressHardSequence, setAddressHardSequence] = useState(null);
  const [buildingName, setBuildingName] = useState(null);
  const [floorUnit, setFloorUnit] = useState(null);
  const [, setStreetNoLow] = useState(null);
  const [, setStreetNoHigh] = useState(null);
  const [, setStreetName] = useState(null);
  const [, setStreetExtension] = useState(null);
  const [suburbName, setSuburbName] = useState(null);
  const [stateCode, setStateCode] = useState(null);
  const [postcodeValue, setPostcodeValue] = useState(null);
  const [streetAddressFull, setStreetAddressFull] = useState(null);
  const [showPropertyIntegrationsModal, setShowPropertyIntegrationsModal] = useState(false);

  const syncLeaseAddressFields = useCallback((partial = {}) => {
    if (Object.prototype.hasOwnProperty.call(partial, "address_id")) {
      setAddressRecordId(partial.address_id ?? null);
    }
    if (Object.prototype.hasOwnProperty.call(partial, "address_hard_sequence")) {
      setAddressHardSequence(partial.address_hard_sequence ?? null);
    }
    if (Object.prototype.hasOwnProperty.call(partial, "building_name")) {
      setBuildingName(partial.building_name ?? null);
    }
    if (Object.prototype.hasOwnProperty.call(partial, "floor_unit")) {
      setFloorUnit(partial.floor_unit ?? null);
    }
    if (Object.prototype.hasOwnProperty.call(partial, "street_no_low")) {
      setStreetNoLow(partial.street_no_low ?? null);
    }
    if (Object.prototype.hasOwnProperty.call(partial, "street_no_high")) {
      setStreetNoHigh(partial.street_no_high ?? null);
    }
    if (Object.prototype.hasOwnProperty.call(partial, "street_name")) {
      setStreetName(partial.street_name ?? null);
    }
    if (Object.prototype.hasOwnProperty.call(partial, "extension")) {
      setStreetExtension(partial.extension ?? null);
    }
    if (Object.prototype.hasOwnProperty.call(partial, "suburb")) {
      setSuburbName(partial.suburb ?? null);
    }
    if (Object.prototype.hasOwnProperty.call(partial, "state_code")) {
      setStateCode(partial.state_code ?? null);
    }
    if (Object.prototype.hasOwnProperty.call(partial, "postcode")) {
      setPostcodeValue(partial.postcode ?? null);
    }
    if (Object.prototype.hasOwnProperty.call(partial, "street_address_full")) {
      setStreetAddressFull(partial.street_address_full ?? null);
    }
  }, []);


  const getRouteLeaseId = (routeProps = props) => {
    const directId = routeParams?.id ?? routeProps?.match?.params?.id ?? routeProps?.params?.id;
    if (directId) {
      return directId;
    }

    const pathname = routeLocation?.pathname ?? routeProps?.location?.pathname ?? window?.location?.pathname ?? "";
    const pathMatch = pathname.match(/\/slmleases\/([^/?#]+)/i);
    return pathMatch ? decodeURIComponent(pathMatch[1]) : null;
  };

  const getRouteState = (routeProps = props) => {
    return routeLocation?.state ?? routeProps?.location?.state ?? routeProps?.routeState ?? null;
  };

  const getBrowseIdList = (currentLeaseId) => {
    const routeState = getRouteState();
    if (Array.isArray(routeState?.data)) {
      storeBrowseIds("slm-lease-browse-ids", routeState.data);
      return routeState.data;
    }

    return readStoredBrowseIds("slm-lease-browse-ids", currentLeaseId);
  };

  const getEffectiveLeaseId = (routeProps = props) => {
    const routeLeaseId = getRouteLeaseId(routeProps);
    const stateLeaseId = stateRef.current?.lease_id;
    return stateLeaseId || (routeLeaseId && routeLeaseId !== "new" ? routeLeaseId : null);
  };

  const pushRoute = (to, state) => {
    if (routeNavigate) {
      if (typeof to === "string") {
        routeNavigate(to, state ? { state } : undefined);
        return;
      }
      routeNavigate(to.pathname, to.state ? { state: to.state } : undefined);
      return;
    }

    if (props?.history?.push) {
      if (typeof to === "string") {
        props.history.push(to, state);
        return;
      }
      props.history.push(to);
      return;
    }

    if (props?.navigate) {
      if (typeof to === "string") {
        props.navigate(to, state ? { state } : undefined);
        return;
      }
      props.navigate(to.pathname, to.state ? { state: to.state } : undefined);
      return;
    }

    if (typeof to === "string") {
      window.location.assign(to);
    } else if (to?.pathname) {
      window.location.assign(to.pathname);
    }
  };

  const routePathname = routeLocation?.pathname ?? props?.location?.pathname;
  const routeMatchId = routeParams?.id ?? props?.match?.params?.id;
  const routeParamId = routeParams?.id ?? props?.params?.id;
  const initialRouteLeaseId = routeMatchId ?? routeParamId ?? (() => {
    const pathMatch = (routePathname ?? window?.location?.pathname ?? "").match(/\/slmleases\/([^/?#]+)/i);
    return pathMatch ? decodeURIComponent(pathMatch[1]) : null;
  })();
  const previousRouteLeaseIdRef = useRef(initialRouteLeaseId);

  useEffect(() => {
    const previousLeaseId = previousRouteLeaseIdRef.current;
    const nextLeaseId = routeMatchId ?? routeParamId ?? (() => {
      const pathMatch = (routePathname ?? window?.location?.pathname ?? "").match(/\/slmleases\/([^/?#]+)/i);
      return pathMatch ? decodeURIComponent(pathMatch[1]) : null;
    })();
    if (previousLeaseId && nextLeaseId && previousLeaseId !== nextLeaseId) {
      setState({
        showAlert: false,
        errorMessage: null,
        modified: false,
      });
    }
    previousRouteLeaseIdRef.current = nextLeaseId;
  }, [routePathname, routeMatchId, routeParamId, setState]);

  const apiRequestOptions = (body, queryParams) => {
    const options = {};

    if (body !== undefined && body !== null) {
      options.body = body;
    }

    if (queryParams !== undefined && queryParams !== null) {
      options.queryParams = queryParams;
    }

    return Object.keys(options).length > 0 ? options : undefined;
  };

  const apiGet = async (path, queryParams = null) => {
    const response = await get({
      apiName: "colin",
      path,
      options: apiRequestOptions(undefined, queryParams),
    }).response;

    return response?.body?.json ? response.body.json() : response;
  };

  const apiPost = async (path, body = null, queryParams = null) => {
    const response = await post({
      apiName: "colin",
      path,
      options: apiRequestOptions(body, queryParams),
    }).response;

    return response?.body?.json ? response.body.json() : response;
  };

  const apiPut = async (path, body = null, queryParams = null) => {
    const response = await put({
      apiName: "colin",
      path,
      options: apiRequestOptions(body, queryParams),
    }).response;

    return response?.body?.json ? response.body.json() : response;
  };

  const apiDel = async (path, queryParams = null) => {
    const response = await del({
      apiName: "colin",
      path,
      options: apiRequestOptions(undefined, queryParams),
    }).response;

    return response?.body?.json ? response.body.json() : response;
  };

  const componentDidMount = async () => {
    const requestId = ++loadRequestIdRef.current;
    const isStaleRequest = () => loadRequestIdRef.current !== requestId;
    try {
      setState({ isLoading: true });
      const routeLeaseId = getRouteLeaseId();
      const routeState = getRouteState();

      if (!routeLeaseId) {
        setState({ isLoading: false, errorMessage: "Missing lease id in route.", showAlert: true });
        return;
      }

      if (routeLeaseId === "new") {
        const dt = new Date();
        const month = String(dt.getMonth() + 1).padStart(2, "0");
        const date = String(dt.getDate()).padStart(2, "0");
        const today = `${dt.getFullYear()}-${month}-${date}`;

        setState((state) => ({
          // Preserve only essential fields from previous record
          titleDetailsSaved: false,
          volumeFoliosSaved: false,
          isLoading: false,
          isDeleting: null,
          lease: {},
          modified: false,
          showAlert: false,
          errorMessage: "",
          idList: [],
          addressFilter: { addressid: -1 },
          agencyFilter: { leaseid: null, saleid: null, agentname: null },
          ownerFilter: { leaseid: null, saleid: null, ownername: null },
          selectedSourceCategories1: null,
          selectedSourceCategories2: null,
          selectedSourceCategories3: null,
          selectedLeaseStatusCategories: NEW_LEASE_DEFAULT_LEASE_STATUS,
          selectedSpaceUseCategories: NEW_LEASE_DEFAULT_SPACE_USE,
          selectedBroadSpaceUseCategories: null,
          selectedQualityTypeCategories: NEW_LEASE_DEFAULT_QUALITY_TYPE,
          selectedLeaseMethodCategories: null,
          selectedLevelCategories: null,
          selectedCarSpaceCategories: null,
          selectedOutgoingsCategories: null,
          selectedRentBasisCategories: null,
          selectedReviewBasisCategories: null,
          selectedRentPerAnnumBasisCategories: null,
          selectedSuburb: null,
          suburbOptions: [],
          entityLinks: [],
          ownerLinks: [],
          agencyOptions: [],
          agents: [],
          showAgencyDialog: false,
          saveForm: false,
          // Reset lease data
          lease_id: null,
          hard_sequence: null,
          // Preserve the selected address context
          address_id: routeState?.address_id ?? null,
          address_hard_sequence: routeState?.address_hard_sequence ?? null,
          building_name: routeState?.building_name ?? null,
          floor_unit: routeState?.floor_unit ?? null,
          street_no_low: routeState?.street_no_low ?? null,
          street_no_high: routeState?.street_no_high ?? null,
          street_name: routeState?.street_name ?? null,
          extension: routeState?.extension ?? null,
          suburb: routeState?.suburb ?? null,
          postcode: routeState?.postcode ?? null,
          state_code: routeState?.state_code ?? null,
          street_address_full: routeState?.street_address_full ?? null,
          // Reset source categories
          source_cat_id: null,
          source_cat: null,
          source_date: null,
          source_page: null,
          source_cat_1_id: null,
          source_cat_1: null,
          source_date_1: null,
          source_page_1: null,
          source_cat_2_id: null,
          source_cat_2: null,
          source_date_2: null,
          source_page_2: null,
          source_cat_3_id: null,
          source_cat_3: null,
          source_date_3: null,
          source_page_3: null,
          // Reset lease details
          lease_commence_date: null,
          rent: null,
          rent_basis: null,
          asking_rent: null,
          space_use_id: NEW_LEASE_DEFAULT_SPACE_USE.value,
          space_use_code: null,
          space_use_name: NEW_LEASE_DEFAULT_SPACE_USE.label,
          broad_space_use_id: null,
          broad_space_use_code: null,
          quality_type_id: NEW_LEASE_DEFAULT_QUALITY_TYPE.value,
          quality_type: NEW_LEASE_DEFAULT_QUALITY_TYPE.label,
          term: null,
          options: null,
          outgoings: null,
          lease_basis: null,
          rent_basis_cat: null,
          tenant_area: null,
          lease_level: null,
          cars: null,
          car_rate: null,
          lease_type: null,
          lease_type_cat_id: null,
          lease_type_cat: null,
          level_description_cat_id: null,
          level_description_cat: null,
          rent_per_annum: null,
          rent_per_annum_basis_cat_id: null,
          rent_per_annum_basis_cat: null,
          outgoing_basis_cat_id: null,
          outgoing_basis_cat: null,
          lease_basis_cat_id: null,
          lease_basis_cat: null,
          lease_status_cat_id: NEW_LEASE_DEFAULT_LEASE_STATUS.value,
          lease_status_cat: NEW_LEASE_DEFAULT_LEASE_STATUS.label,
          car_space_descr_cat_id: null,
          car_space_descr_cat: null,
          lessee: null,
          owner: null,
          agent: null,
          agency: null,
          pending: false,
          estimated: false,
          review: null,
          print_month: today,
          prev_delivery: null,
          stat_date: today,
          editors_note: null,
          note_data: " ",
          lease_notes: null,
          lease_notes_computed: null,
          created_date: new Date(),
          created_by: props.user,
          last_edited_date: null,
          last_edited_by: null,
          archived_date: null,
          unit_number: null,
          titleDetails: [],
          showTitleDetailsDialog: false,
          volumeFolios: [],
          showVolumeFoliosDialog: false,
          integrations: [],
          showAddressMatchingDialog: false,
          title_details: null,
        }));

        // Reassert the selected address context after resetting the lease fields.
        syncLeaseAddressFields({
          address_id: routeState?.address_id ?? null,
          address_hard_sequence: routeState?.address_hard_sequence ?? null,
          building_name: routeState?.building_name ?? null,
          floor_unit: routeState?.floor_unit ?? null,
          street_no_low: routeState?.street_no_low ?? null,
          street_no_high: routeState?.street_no_high ?? null,
          street_name: routeState?.street_name ?? null,
          extension: routeState?.extension ?? null,
          suburb: routeState?.suburb ?? null,
          postcode: routeState?.postcode ?? null,
          state_code: routeState?.state_code ?? null,
          street_address_full: routeState?.street_address_full ?? null,
        });

        if (routeState) {
          if (routeState.clone) {
            await cloneLease();
          } else {
            await syncroniseState();
          }
        }
        if (isStaleRequest()) return;
        document.title = "New lease record";

        // Defensive re-assertion: guards Agents & Agencies against a same-tick stale
        // write (e.g. a lingering fetch from the previous record) clobbering the reset.
        await new Promise((resolve) => setTimeout(resolve, 50));
        if (!isStaleRequest() && getRouteLeaseId() === "new") {
          setState({ agent: null, agency: null, entityLinks: [] });
        }
      } else {
        await retrieveLease();
        if (isStaleRequest()) return;
        await getVolumeFolios();
        await getTitleDetails();
        await getIntegrations();
        if (isStaleRequest()) return;
        {
          const parsedRouteLeaseId = parseInt(routeLeaseId, 10);
          const idList = getBrowseIdList(parsedRouteLeaseId)
            .map((id) => Number(id))
            .filter((id) => Number.isFinite(id));

          setState({
            idList,
          });
        }

        const resolvedLeaseId = getEffectiveLeaseId() || routeLeaseId;
        const agencyFilter = { ...stateRef.current.agencyFilter, leaseid: resolvedLeaseId };
        const ownerFilter = { ...stateRef.current.ownerFilter, leaseid: resolvedLeaseId };

        setState({ agencyFilter, ownerFilter });

        //Get agency records NEW
        const entityLinks = await getEntityLinks(agencyFilter);
        if (isStaleRequest()) return;
        setState({ entityLinks });

        const ownerLinks = await getOwnerLinks(ownerFilter);
        if (isStaleRequest()) return;
        setState({ ownerLinks });

        document.title = "Lease: " + (getEffectiveLeaseId() || "");
      }
      if (isStaleRequest()) return;
      setState({
        addressFilter: { addressid: addressRecordId ?? stateRef.current.address_id },
        selectedSourceCategories1: { value: stateRef.current.source_cat_1_id, label: stateRef.current.source_cat_1 },
        selectedSourceCategories2: { value: stateRef.current.source_cat_2_id, label: stateRef.current.source_cat_2 },
        selectedSourceCategories3: { value: stateRef.current.source_cat_3_id, label: stateRef.current.source_cat_3 },
        selectedLeaseStatusCategories: { value: stateRef.current.lease_status_cat_id, label: stateRef.current.lease_status_cat },
        selectedSpaceUseCategories: { value: stateRef.current.space_use_id, label: stateRef.current.space_use_name },
        selectedBroadSpaceUseCategories: { value: stateRef.current.broad_space_use_id, label: stateRef.current.broad_space_use_code },
        selectedQualityTypeCategories: { value: stateRef.current.quality_type_id, label: stateRef.current.quality_type },
        selectedCarSpaceCategories: { value: stateRef.current.car_space_descr_cat_id, label: stateRef.current.car_space_descr_cat },
        selectedLeaseMethodCategories: { value: stateRef.current.lease_type_cat_id, label: stateRef.current.lease_type_cat },
        selectedLevelCategories: { value: stateRef.current.level_description_cat_id, label: stateRef.current.level_description_cat },
        selectedOutgoingsCategories: { value: stateRef.current.outgoing_basis_cat_id, label: stateRef.current.outgoing_basis_cat },
        selectedRentBasisCategories: { value: stateRef.current.rent_basis, label: stateRef.current.rent_basis_cat },
        selectedReviewBasisCategories: { value: stateRef.current.lease_basis, label: stateRef.current.lease_basis_cat },
        selectedRentPerAnnumBasisCategories: { value: stateRef.current.rent_per_annum_basis_cat_id, label: stateRef.current.rent_per_annum_basis_cat },
      });

      setState({ isLoading: false });
    } catch (e) {
      alert(e);
    }
  }

  useEffect(() => {
    componentDidMount();
    // Intentionally no cleanup to preserve legacy behavior.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [routeLocation.pathname]);

  const cloneLeaseParcels = async (clonedLeaseId, newLeaseId = null) => {
    if (newLeaseId && stateRef.current.titleDetails) {
      const parcels = stateRef.current.titleDetails.map((p) => {
        return { ...p, lease_id: newLeaseId };
      });
      await apiPost(`/slmleases/${clonedLeaseId}/parcels_bulk/null`, parcels);
      return;
    }

    const parcels = await apiGet(`/slmleases/${clonedLeaseId}/parcels`);
    for (const parcel of parcels) {
      parcel.parcel_id = null;
      parcel.lease_id = null;
      parcel._cloned = true; // Signals to the back-end not to create integrations
    }
    setState({ titleDetails: parcels });
  }

  const cloneLeaseVolumeFolios = async (clonedLeaseId, newLeaseId = null) => {
    if (newLeaseId && stateRef.current.volumeFolios) {
      const volumeFolios = stateRef.current.volumeFolios.map((vf) => {
        return { ...vf, lease_id: newLeaseId };
      });
      await apiPost(`/slmleases/${newLeaseId}/volume_folios_bulk/null`, volumeFolios);
      return;
    }

    const volumeFolios = await apiGet(`/slmleases/${clonedLeaseId}/volume_folios`);
    for (const volumeFolio of volumeFolios) {
      volumeFolio.volume_folio_id = null;
      volumeFolio.lease_id = null;
    }
    setState({ volumeFolios: volumeFolios });
  }

  const cloneLeaseIntegrations = async (clonedLeaseId, newLeaseId = null) => {
    if (newLeaseId && stateRef.current.integrations) {
      const integrations = stateRef.current.integrations.map((i) => {
        return { ...i, lease_id: newLeaseId };
      });
      await apiPost(`/slmleases/${newLeaseId}/integrations_bulk/null`, integrations);
      return;
    }

    const integrations = await apiGet(`/slmleases/${clonedLeaseId}/integrations`);
    for (const integration of integrations) {
      integration.integration_id = null;
      integration.lease_id = null;
    }
    setState({ integrations: integrations });
  }

  const cloneLease = async () => {
    const lease = getRouteState()?.clone;
    if (!lease) {
      return;
    }
    const {
      address_id,
      address_hard_sequence,
      street_address_full,
      building_name,
      street_no_low,
      street_no_high,
      street_name,
      extension,
      suburb,
      postcode,
      state_code,
      tenant_area,

      rent,
      rent_basis,
      rent_basis_cat,
      asking_rent,
      space_use_id,
      space_use_code,
      space_use_name,
      broad_space_use_id,
      broad_space_use_code,
      quality_type_id,
      quality_type,
      outgoings,
      lease_basis,
      cars,
      car_rate,
      lease_type,
      lease_type_cat_id,
      lease_type_cat,
      lease_level,
      level_description_cat_id,
      level_description_cat,
      rent_per_annum,
      rent_per_annum_basis_cat_id,
      rent_per_annum_basis_cat,
      outgoing_basis_cat_id,
      outgoing_basis_cat,
      lease_basis_cat_id,
      lease_basis_cat,
      lease_status_cat_id,
      lease_status_cat,
      car_space_descr_cat_id,
      car_space_descr_cat,
      pending,
      estimated,
      review,
      unit_number,
      lease_notes,
    } = lease;

    setState({
      lease,
      address_id,
      address_hard_sequence,
      street_address_full,
      building_name,
      street_no_low,
      street_no_high,
      street_name,
      extension,
      suburb,
      postcode,
      state_code,
      tenant_area,

      rent,
      rent_basis,
      rent_basis_cat,
      asking_rent,
      space_use_id,
      space_use_code,
      space_use_name,
      broad_space_use_id,
      broad_space_use_code,
      quality_type_id,
      quality_type,
      outgoings,
      lease_basis,
      cars,
      car_rate,
      lease_type,
      lease_type_cat_id,
      lease_type_cat,
      lease_level,
      level_description_cat_id,
      level_description_cat,
      rent_per_annum,
      rent_per_annum_basis_cat_id,
      rent_per_annum_basis_cat,
      outgoing_basis_cat_id,
      outgoing_basis_cat,
      lease_basis_cat_id,
      lease_basis_cat,
      lease_status_cat_id,
      lease_status_cat,
      car_space_descr_cat_id,
      car_space_descr_cat,
      pending,
      estimated,
      review,
      unit_number,
      lease_notes,
    });
    syncLeaseAddressFields({
      address_id,
      address_hard_sequence,
      building_name,
      floor_unit: floorUnit,
      street_no_low,
      street_no_high,
      street_name,
      extension,
      suburb,
      state_code,
      postcode,
      street_address_full,
    });

    cloneLeaseParcels(lease.lease_id, null);
    cloneLeaseVolumeFolios(lease.lease_id, null);
    cloneLeaseIntegrations(lease.lease_id, null);

    const clonedLease = await apiGet(`/slmleases/${lease.lease_id}`);
    setState({ title_details: clonedLease.title_details });
    setState({ lease_notes_computed: clonedLease.lease_notes_computed });
  }

  const retrieveLease = async () => {
    const lease = await getLease();
    const {
      lease_id,
      origin_db,
      hard_sequence,
      address_id,
      address_hard_sequence,
      building_name,
      floor_unit,
      street_no_low,
      street_no_high,
      street_name,
      extension,
      suburb,
      postcode,
      state_code,
      street_address_full,
      source_cat_id,
      source_cat,
      source_date,
      source_page,
      source_cat_1_id,
      source_cat_1,
      source_date_1,
      source_page_1,
      source_cat_2_id,
      source_cat_2,
      source_date_2,
      source_page_2,
      source_cat_3_id,
      source_cat_3,
      source_date_3,
      source_page_3,
      lease_commence_date,
      rent,
      rent_basis,
      rent_basis_cat,
      space_use_id,
      space_use_code,
      space_use_name,
      broad_space_use_id,
      broad_space_use_code,
      quality_type_id,
      quality_type,
      term,
      options,
      outgoings,
      lease_basis,
      tenant_area,
      lease_level,
      cars,
      car_rate,
      lease_type,
      lease_type_cat_id,
      lease_type_cat,
      level_description_cat_id,
      level_description_cat,
      rent_per_annum,
      rent_per_annum_basis_cat_id,
      rent_per_annum_basis_cat,
      outgoing_basis_cat_id,
      outgoing_basis_cat,
      lease_basis_cat_id,
      lease_basis_cat,
      lease_status_cat_id,
      lease_status_cat,
      car_space_descr_cat_id,
      car_space_descr_cat,
      lessee,
      owner,
      agent,
      agency,
      pending,
      estimated,
      review,
      print_month,
      prev_delivery,
      stat_date,
      editors_note,
      note_data,
      lease_notes,
      lease_notes_computed,
      created_date,
      created_by,
      last_edited_date,
      last_edited_by,
      unit_number,
      title_details,
    } = lease;

    setState({
      lease,
      lease_id,
      origin_db,
      hard_sequence,
      address_id,
      address_hard_sequence,
      building_name,
      floor_unit,
      street_no_low,
      street_no_high,
      street_name,
      extension,
      suburb,
      postcode,
      state_code,
      street_address_full,
      source_cat_id,
      source_cat,
      source_date,
      source_page,
      source_cat_1_id,
      source_cat_1,
      source_date_1,
      source_page_1,
      source_cat_2_id,
      source_cat_2,
      source_date_2,
      source_page_2,
      source_cat_3_id,
      source_cat_3,
      source_date_3,
      source_page_3,
      lease_commence_date,
      rent,
      rent_basis,
      rent_basis_cat,
      space_use_id,
      space_use_code,
      space_use_name,
      broad_space_use_id,
      broad_space_use_code,
      quality_type_id,
      quality_type,
      term,
      options,
      outgoings,
      lease_basis,
      tenant_area,
      lease_level,
      cars,
      car_rate,
      lease_type,
      lease_type_cat_id,
      lease_type_cat,
      level_description_cat_id,
      level_description_cat,
      rent_per_annum,
      rent_per_annum_basis_cat_id,
      rent_per_annum_basis_cat,
      outgoing_basis_cat_id,
      outgoing_basis_cat,
      lease_basis_cat_id,
      lease_basis_cat,
      lease_status_cat_id,
      lease_status_cat,
      car_space_descr_cat_id,
      car_space_descr_cat,
      lessee,
      owner,
      agent,
      agency,
      pending,
      estimated,
      review,
      print_month,
      prev_delivery,
      stat_date,
      editors_note,
      note_data,
      lease_notes,
      lease_notes_computed,
      created_date,
      created_by,
      last_edited_date,
      last_edited_by,
      unit_number,
      title_details,
    });
    syncLeaseAddressFields({
      address_id,
      address_hard_sequence,
      building_name,
      floor_unit,
      street_no_low,
      street_no_high,
      street_name,
      extension,
      suburb,
      state_code,
      postcode,
      street_address_full,
    });
  }

  const syncroniseState = async () => {
    const lease = {
      lease_id: stateRef.current.lease_id,
      origin_db: stateRef.current.origin_db,
      hard_sequence: stateRef.current.hard_sequence,
      address_id: stateRef.current.address_id,
      address_hard_sequence: stateRef.current.address_hard_sequence,
      building_name: stateRef.current.building_name,
      floor_unit: stateRef.current.floor_unit,
      street_no_low: stateRef.current.street_no_low,
      street_no_high: stateRef.current.street_no_high,
      street_name: stateRef.current.street_name,
      extension: stateRef.current.extension,
      suburb: stateRef.current.suburb,
      postcode: stateRef.current.postcode,
      state_code: stateRef.current.state_code,
      street_address_full: stateRef.current.street_address_full,
      source_cat_id: stateRef.current.source_cat_id,
      source_cat: stateRef.current.source_cat,
      source_date: stateRef.current.source_date,
      source_page: stateRef.current.source_page,
      source_cat_1_id: stateRef.current.source_cat_1_id,
      source_cat_1: stateRef.current.source_cat_1,
      source_date_1: stateRef.current.source_date_1,
      source_page_1: stateRef.current.source_page_1,
      source_cat_2_id: stateRef.current.source_cat_2_id,
      source_cat_2: stateRef.current.source_cat_2,
      source_date_2: stateRef.current.source_date_2,
      source_page_2: stateRef.current.source_page_2,
      source_cat_3_id: stateRef.current.source_cat_3_id,
      source_cat_3: stateRef.current.source_cat_3,
      source_date_3: stateRef.current.source_date_3,
      source_page_3: stateRef.current.source_page_3,
      lease_commence_date: stateRef.current.lease_commence_date,
      rent: stateRef.current.rent,
      rent_basis: stateRef.current.rent_basis,
      rent_basis_cat: stateRef.current.rent_basis_cat,
      asking_rent: stateRef.current.asking_rent,
      space_use_id: stateRef.current.space_use_id,
      space_use_code: stateRef.current.space_use_code,
      space_use_name: stateRef.current.space_use_name,
      broad_space_use_id: stateRef.current.broad_space_use_id,
      broad_space_use_code: stateRef.current.broad_space_use_code,
      quality_type_id: stateRef.current.quality_type_id,
      quality_type: stateRef.current.quality_type,
      term: stateRef.current.term,
      options: stateRef.current.options,
      outgoings: stateRef.current.outgoings,
      lease_basis: stateRef.current.lease_basis,
      tenant_area: stateRef.current.tenant_area,
      lease_level: stateRef.current.lease_level,
      cars: stateRef.current.cars,
      car_rate: stateRef.current.car_rate,
      lease_type: stateRef.current.lease_type,
      lease_type_cat_id: stateRef.current.lease_type_cat_id,
      lease_type_cat: stateRef.current.lease_type_cat,
      level_description_cat_id: stateRef.current.level_description_cat_id,
      level_description_cat: stateRef.current.level_description_cat,
      rent_per_annum: stateRef.current.rent_per_annum,
      rent_per_annum_basis_cat_id: stateRef.current.rent_per_annum_basis_cat_id,
      rent_per_annum_basis_cat: stateRef.current.rent_per_annum_basis_cat,
      outgoing_basis_cat_id: stateRef.current.outgoing_basis_cat_id,
      outgoing_basis_cat: stateRef.current.outgoing_basis_cat,
      lease_basis_cat_id: stateRef.current.lease_basis_cat_id,
      lease_basis_cat: stateRef.current.lease_basis_cat,
      lease_status_cat_id: stateRef.current.lease_status_cat_id,
      lease_status_cat: stateRef.current.lease_status_cat,
      car_space_descr_cat_id: stateRef.current.car_space_descr_cat_id,
      car_space_descr_cat: stateRef.current.car_space_descr_cat,
      lessee: stateRef.current.lessee,
      owner: stateRef.current.owner,
      agent: stateRef.current.agent,
      agency: stateRef.current.agency,
      pending: stateRef.current.pending,
      estimated: stateRef.current.estimated,
      review: stateRef.current.review,
      print_month: stateRef.current.print_month,
      prev_delivery: stateRef.current.prev_delivery,
      stat_date: stateRef.current.stat_date,
      editors_note: stateRef.current.editors_note,
      note_data: stateRef.current.note_data,
      lease_notes: stateRef.current.lease_notes,
      lease_notes_computed: stateRef.current.lease_notes_computed,
      created_date: stateRef.current.created_date,
      created_by: stateRef.current.created_by,
      last_edited_date: stateRef.current.last_edited_date,
      last_edited_by: stateRef.current.last_edited_by,
      archived_date: stateRef.current.archived_date,
      unit_number: stateRef.current.unit_number,
      title_details: stateRef.current.title_details,
    };
    stateRef.current.lease = lease;
    setState({ lease });
    return lease;
  }

  const getLease = async () => {
    const routeLeaseId = getRouteLeaseId();
    if (!routeLeaseId || routeLeaseId === "null" || routeLeaseId === "undefined") {
      throw new Error("Missing lease id in route.");
    }
    return apiGet(`/slmleases/${routeLeaseId}`);
  }

  const saveLease = async (lease) => {
    setState({ last_edited_by: props.user });
    const routeLeaseId = getRouteLeaseId();
    if (routeLeaseId === "new" && stateRef.current.lease_id === null) {
      setState({ created_by: props.user });
      const response = await apiPost(`/slmleases/new`, lease);
      try {
        return await response;
      } catch (error) {
        alert(error + ". Please refresh the page (F5) to try again.");
      }
    }
    const effectiveLeaseId = getEffectiveLeaseId();
    if (!effectiveLeaseId) {
      throw new Error("Missing lease id for update.");
    }
    const response = apiPut(`/slmleases/${effectiveLeaseId}`, lease);
    try {
      return await response;
    } catch (error) {
      alert(error + ". Please refresh the page (F5) to try again.");
    }
  }

  //new

  const getEntityLinks = async (filter) => {
    const response = apiGet(`/slmentitylinks`, filter);
    try {
      return await response;
    } catch (error) {
      alert(error + ". Please refresh the page (F5) to try again.");
    }
  }

  const getOwnerLinks = async (filter) => {
    const response = apiGet(`/slmownerlinks`, filter);
    try {
      return await response;
    } catch (error) {
      alert(error + ". Please refresh the page (F5) to try again.");
    }
  }

  const getAgencies = async (filter) => {
    const response = apiGet(`/slmentities`, filter);
    try {
      return await response;
    } catch (error) {
      alert(error + ". Please refresh the page (F5) to try again.");
    }
  }

  const getAgents = async (filter) => {
    const response = apiGet(`/slmagents`, filter);
    try {
      return await response;
    } catch (error) {
      alert(error + ". Please refresh the page (F5) to try again.");
    }
  }

  const getOwners = async (filter) => {
    const response = apiGet(`/slmowners`, filter);
    try {
      return await response;
    } catch (error) {
      alert(error + ". Please refresh the page (F5) to try again.");
    }
  }

  const getContacts = async (filter) => {
    const response = apiGet(`/slmowners/${filter.orgid}/slmcontacts`, filter);
    try {
      return await response;
    } catch (error) {
      alert(error + ". Please refresh the page (F5) to try again.");
    }
  }

  //new
  const updateTableState = async (data, set) => {
    setState({
      [set]: data,
    });
    return true;
  }
  //new
  const saveRecord = (record, endpoint, id) => {
    if (endpoint === "slmTitleDetailsBulk") {
      return apiPost(`/slmleases/${record[0].lease_id}/parcels_bulk/${id}`, record);
    }

    record.last_edited_by = props.user;
    //If the record is a new record perform a post
    if (record.hasOwnProperty("new_record")) {
      if (record.new_record === true) {
        if (endpoint === "slmTitleDetails") {
          setState({ titleDetailsSaved: true });
          const response = apiPost(`/slmleases/${record["lease_id"]}/parcels/new`, record);
          return response;
        }

        if (endpoint === "slmVolumeFolios") {
          setState({ volumeFoliosSaved: true });
          return apiPost(`/slmleases/${record["lease_id"]}/volume_folios/new`, record);
        }

        if (endpoint === "slmPropertyIntegrations") {
          const response = apiPost(`/slmleases/${record["lease_id"]}/integrations/${record[id]}`, record);
          response.then((response) => {
            if (response.result === true) {
              getTitleDetails();
            }
          });
          return response;
        }

        record.last_edited_by = props.user;
        return apiPost(`/slm${endpoint.toLowerCase()}/new`, record);
      }
    }

    if (endpoint === "slmTitleDetails") {
      setState({ titleDetailsSaved: true });
      const response = apiPut(`/slmleases/${record["lease_id"]}/parcels/${record[id]}`, record);
      return response;
    }

    if (endpoint === "slmVolumeFolios") {
      setState({ volumeFoliosSaved: true });
      return apiPut(`/slmleases/${record["lease_id"]}/volume_folios/${record[id]}`, record);
    }

    if (endpoint === "slmPropertyIntegrations") {
      const response = apiPut(`/slmleases/${record["lease_id"]}/integrations/${record[id]}`, record);
      response.then((response) => {
        if (response.result === true) {
          getTitleDetails();
        }
      });
      return response;
    }

    return apiPut(`/slm${endpoint.toLowerCase()}/${record[id]}`, record);
  }

  const deleteRecord = (endpoint, params) => {
    return apiDel(`/${endpoint}`, params);
  }

  const validateRelatedRecord = (record, set) => {
    //address
    if (set === "lease") {
      if (stateRef.current.stat_date === null) {
        return [false, "You must enter a stat date"];
      }

      if (stateRef.current.space_use_id === null) {
        return [false, "You must select a space use."];
      }

      if (stateRef.current.quality_type_id === null) {
        return [false, "You must select a quality type."];
      }

      if (exceedsIntegerColumn(stateRef.current.rent_per_annum)) {
        return [false, "Rent per Annum is too large to be saved. Please enter a smaller value."];
      }

      for (const [field, maxLength, label] of LEASE_TEXT_COLUMN_LIMITS) {
        const value = stateRef.current[field];
        if (value && String(value).length > maxLength) {
          return [false, `${label} cannot be longer than ${maxLength} characters.`];
        }
      }
    }

    return [true, ""];
  }

  const navigateToBrowseLeaseRecord = (targetId, browseIds = stateRef.current.idList) => {
    storeBrowseIds("slm-lease-browse-ids", browseIds);
    pushRoute({ pathname: `/slmleases/${targetId}`, state: { data: browseIds } });
  };

  const handleSource1Change = (selectedSourceCategories1) => {
    if (selectedSourceCategories1) {
      stateRef.current = { ...stateRef.current, selectedSourceCategories1, source_cat_1_id: selectedSourceCategories1.value, source_cat_1: selectedSourceCategories1.label };
      setState({ selectedSourceCategories1, source_cat_1_id: selectedSourceCategories1.value, source_cat_1: selectedSourceCategories1.label, modified: true }, handleBlur);
    } else {
      stateRef.current = { ...stateRef.current, selectedSourceCategories1: { value: null, label: null }, source_cat_1_id: null, source_cat_1: null };
      setState({ selectedSourceCategories1: { value: null, label: null }, source_cat_1_id: null, source_cat_1: null, modified: true }, handleBlur);
    }
  };
  const handleSource2Change = (selectedSourceCategories2) => {
    if (selectedSourceCategories2) {
      stateRef.current = { ...stateRef.current, selectedSourceCategories2, source_cat_2_id: selectedSourceCategories2.value, source_cat_2: selectedSourceCategories2.label };
      setState({ selectedSourceCategories2, source_cat_2_id: selectedSourceCategories2.value, source_cat_2: selectedSourceCategories2.label, modified: true }, handleBlur);
    } else {
      stateRef.current = { ...stateRef.current, selectedSourceCategories2: { value: null, label: null }, source_cat_2_id: null, source_cat_2: null };
      setState({ selectedSourceCategories2: { value: null, label: null }, source_cat_2_id: null, source_cat_2: null, modified: true }, handleBlur);
    }
  };

  const handleSource3Change = (selectedSourceCategories3) => {
    if (selectedSourceCategories3) {
      // Update stateRef immediately to avoid race condition in handleBlur
      stateRef.current = { ...stateRef.current, selectedSourceCategories3, source_cat_3_id: selectedSourceCategories3.value, source_cat_3: selectedSourceCategories3.label };
      setState({ selectedSourceCategories3, source_cat_3_id: selectedSourceCategories3.value, source_cat_3: selectedSourceCategories3.label, modified: true }, handleBlur);
    } else {
      stateRef.current = { ...stateRef.current, selectedSourceCategories3: { value: null, label: null }, source_cat_3_id: null, source_cat_3: null };
      setState({ selectedSourceCategories3: { value: null, label: null }, source_cat_3_id: null, source_cat_3: null, modified: true }, handleBlur);
    }
  };

  const handleStatusChange = (selectedLeaseStatusCategories) => {
    if (selectedLeaseStatusCategories) {
      stateRef.current = { ...stateRef.current, selectedLeaseStatusCategories, lease_status_cat_id: selectedLeaseStatusCategories.value };
      setState({ selectedLeaseStatusCategories, lease_status_cat_id: selectedLeaseStatusCategories.value, modified: true }, handleBlur);
    } else {
      stateRef.current = { ...stateRef.current, selectedLeaseStatusCategories: { value: null, label: null }, lease_status_cat_id: null };
      setState({ selectedLeaseStatusCategories: { value: null, label: null }, lease_status_cat_id: null, modified: true }, handleBlur);
    }
  };

  const handleReviewBasisCategoryChange = (selectedReviewBasisCategories) => {
    if (selectedReviewBasisCategories) {
      stateRef.current = { ...stateRef.current, selectedReviewBasisCategories, lease_basis_cat_id: selectedReviewBasisCategories.value };
      setState({ selectedReviewBasisCategories, lease_basis_cat_id: selectedReviewBasisCategories.value, modified: true }, handleBlur);
    } else {
      stateRef.current = { ...stateRef.current, selectedReviewBasisCategories: { value: null, label: null }, lease_basis_cat_id: null };
      setState({ selectedReviewBasisCategories: { value: null, label: null }, lease_basis_cat_id: null, modified: true }, handleBlur);
    }
  };

  const handleLevelCategoryChange = (selectedLevelCategories) => {
    if (selectedLevelCategories) {
      stateRef.current = { ...stateRef.current, selectedLevelCategories, level_description_cat_id: selectedLevelCategories.value };
      setState({ selectedLevelCategories, level_description_cat_id: selectedLevelCategories.value, modified: true }, handleBlur);
    } else {
      stateRef.current = { ...stateRef.current, selectedLevelCategories: { value: null, label: null }, level_description_cat_id: null };
      setState({ selectedLevelCategories: { value: null, label: null }, level_description_cat_id: null, modified: true }, handleBlur);
    }
  };

  const handleOutgoingsCategoryChange = (selectedOutgoingsCategories) => {
    if (selectedOutgoingsCategories) {
      stateRef.current = { ...stateRef.current, selectedOutgoingsCategories, outgoing_basis_cat_id: selectedOutgoingsCategories.value };
      setState({ selectedOutgoingsCategories, outgoing_basis_cat_id: selectedOutgoingsCategories.value, modified: true }, handleBlur);
    } else {
      stateRef.current = { ...stateRef.current, selectedOutgoingsCategories: { value: null, label: null }, outgoing_basis_cat_id: null };
      setState({ selectedOutgoingsCategories: { value: null, label: null }, outgoing_basis_cat_id: null, modified: true }, handleBlur);
    }
  };

  const handleRentBasisCategoryChange = (selectedRentBasisCategories) => {
    if (selectedRentBasisCategories) {
      stateRef.current = { ...stateRef.current, selectedRentBasisCategories, rent_basis: selectedRentBasisCategories.value };
      setState({ selectedRentBasisCategories, rent_basis: selectedRentBasisCategories.value, modified: true }, handleBlur);
    } else {
      stateRef.current = { ...stateRef.current, selectedRentBasisCategories: { value: null, label: null }, rent_basis: null };
      setState({ selectedRentBasisCategories: { value: null, label: null }, rent_basis: null, modified: true }, handleBlur);
    }
  };

  const handleRentPerAnnumBasisCategoryChange = (selectedRentPerAnnumBasisCategories) => {
    if (selectedRentPerAnnumBasisCategories) {
      stateRef.current = { ...stateRef.current, selectedRentPerAnnumBasisCategories, rent_per_annum_basis_cat_id: selectedRentPerAnnumBasisCategories.value };
      setState({ selectedRentPerAnnumBasisCategories, rent_per_annum_basis_cat_id: selectedRentPerAnnumBasisCategories.value, modified: true }, handleBlur);
    } else {
      stateRef.current = { ...stateRef.current, selectedRentPerAnnumBasisCategories: { value: null, label: null }, rent_per_annum_basis_cat_id: null };
      setState({ selectedRentPerAnnumBasisCategories: { value: null, label: null }, rent_per_annum_basis_cat_id: null, modified: true }, handleBlur);
    }
  };

  const handleBroadSpaceUseChange = async (selectedBroadSpaceUseCategories) => {
    if (selectedBroadSpaceUseCategories) {
      stateRef.current = { ...stateRef.current, selectedBroadSpaceUseCategories, broad_space_use_id: selectedBroadSpaceUseCategories.value, selectedSpaceUseCategories: { value: null, label: null }, space_use_id: null };
      setState({ selectedBroadSpaceUseCategories, broad_space_use_id: selectedBroadSpaceUseCategories.value, modified: true, selectedSpaceUseCategories: { value: null, label: null }, space_use_id: null }, handleBlur);
    } else {
      stateRef.current = { ...stateRef.current, selectedBroadSpaceUseCategories: { value: null, label: null }, broad_space_use_id: null, selectedSpaceUseCategories: { value: null, label: null }, space_use_id: null };
      setState({ selectedBroadSpaceUseCategories: { value: null, label: null }, broad_space_use_id: null, modified: true, selectedSpaceUseCategories: { value: null, label: null }, space_use_id: null }, handleBlur);
    }
  };

  const handleSpaceUseChange = (selectedSpaceUseCategories) => {
    if (selectedSpaceUseCategories) {
      const updateObj = {
        selectedSpaceUseCategories,
        space_use_id: selectedSpaceUseCategories.value,
        broad_space_use_id: selectedSpaceUseCategories.supplementary_details.broad_space_use_id,
        modified: true,
        selectedBroadSpaceUseCategories: { value: selectedSpaceUseCategories.supplementary_details.broad_space_use_id, label: selectedSpaceUseCategories.supplementary_details.broad_space_use_code },
      };
      stateRef.current = { ...stateRef.current, ...updateObj };
      setState(updateObj, handleBlur);
    } else {
      stateRef.current = { ...stateRef.current, selectedSpaceUseCategories: { value: null, label: null }, space_use_id: null };
      setState({ selectedSpaceUseCategories: { value: null, label: null }, space_use_id: null, modified: true }, handleBlur);
    }
  };

  const handleQualityTypeChange = (selectedQualityTypeCategories) => {
    if (selectedQualityTypeCategories) {
      stateRef.current = { ...stateRef.current, selectedQualityTypeCategories, quality_type_id: selectedQualityTypeCategories.value };
      setState({ selectedQualityTypeCategories, quality_type_id: selectedQualityTypeCategories.value, modified: true }, handleBlur);
    } else {
      stateRef.current = { ...stateRef.current, selectedQualityTypeCategories: { value: null, label: null }, quality_type_id: null };
      setState({ selectedQualityTypeCategories: { value: null, label: null }, quality_type_id: null, modified: true }, handleBlur);
    }
  };

  const handleLeaseMethodChange = (selectedLeaseMethodCategories) => {
    if (selectedLeaseMethodCategories) {
      const lease_type = props.leaseTypes.filter((a) => {
        if (a.value === selectedLeaseMethodCategories.value) {
          return true;
        } else {
          return false;
        }
      });

      const updateObj = { selectedLeaseMethodCategories, lease_type: lease_type[0]?.label ?? selectedLeaseMethodCategories.label ?? null, lease_type_cat: selectedLeaseMethodCategories.label ?? null, lease_type_cat_id: selectedLeaseMethodCategories.value, modified: true };
      stateRef.current = { ...stateRef.current, ...updateObj };
      setState(updateObj, handleBlur);
    } else {
      stateRef.current = { ...stateRef.current, selectedLeaseMethodCategories: { value: null, label: null }, lease_type_cat_id: null, lease_type: null, lease_type_cat: null };
      setState({ selectedLeaseMethodCategories: { value: null, label: null }, lease_type_cat_id: null, lease_type: null, lease_type_cat: null, modified: true }, handleBlur);
    }
  };

  const handleCarSpaceChange = (selectedCarSpaceCategories) => {
    if (selectedCarSpaceCategories) {
      stateRef.current = { ...stateRef.current, selectedCarSpaceCategories, car_space_descr_cat_id: selectedCarSpaceCategories.value };
      setState({ selectedCarSpaceCategories, car_space_descr_cat_id: selectedCarSpaceCategories.value, modified: true }, handleBlur);
    } else {
      stateRef.current = { ...stateRef.current, selectedCarSpaceCategories: { value: null, label: null }, car_space_descr_cat_id: null };
      setState({ selectedCarSpaceCategories: { value: null, label: null }, car_space_descr_cat_id: null, modified: true }, handleBlur);
    }
  };

  const handleChange = (event) => {
    const fieldId = event.target.name || event.target.id;
    const fieldValue = event.target.value.trimStart();
    setState({ [fieldId]: fieldValue });

    switch (fieldId) {
      case "address_id":
        setAddressRecordId(fieldValue || null);
        break;
      case "building_name":
        setBuildingName(fieldValue || null);
        break;
      case "floor_unit":
        setFloorUnit(fieldValue || null);
        break;
      case "street_no_low":
        setStreetNoLow(fieldValue || null);
        break;
      case "street_no_high":
        setStreetNoHigh(fieldValue || null);
        break;
      case "street_name":
        setStreetName(fieldValue || null);
        break;
      case "extension":
        setStreetExtension(fieldValue || null);
        break;
      case "suburb":
        setSuburbName(fieldValue || null);
        break;
      case "state_code":
        setStateCode(fieldValue || null);
        break;
      case "postcode":
        setPostcodeValue(fieldValue || null);
        break;
      case "street_address_full":
        setStreetAddressFull(fieldValue || null);
        break;
      default:
        break;
    }
    setState({ modified: true });
  };

  const handleNumberChange = (event) => {
    const fieldId = event.target.name || event.target.id;
    let val = event.target.value.replace(/[^0-9.]/g, "");
    setState({ [fieldId]: val, modified: true });
  };

  const handleMoneyChange = (event) => {
    const fieldId = event.target.name || event.target.id;
    if (event.target.value !== "") {
      let val = event.target.value.replace(/[^0-9.]/g, "").replace(/(?<=[.][0-9]{2})[0-9]*/g, "");
      setState({ [fieldId]: val, modified: true });
    } else {
      setState({ [fieldId]: null, modified: true });
    }
  };

  const handleNonNegativeNumberChange = (event) => {
    const fieldId = event.target.name || event.target.id;
    const rawValue = event.target.value;

    if (rawValue === "") {
      setState({ [fieldId]: "", modified: true });
      return;
    }

    const parsedValue = Number.parseInt(rawValue, 10);
    const nextValue = Number.isNaN(parsedValue) ? "" : String(Math.max(0, parsedValue));
    setState({ [fieldId]: nextValue, modified: true });
  };

  const handleDateChange = (date, name) => {
    var options = { year: "numeric", month: "long", day: "numeric" };

    var dt = new Date(date);
    const today = new Date();

    if (name === "print_month") {
      if (dt.getTime() < today.getTime()) {
        alert("Delivery date cannot be earlier than today");
        return;
      }
    }
    if (date) {
      if (name === "lease_commence_date") {
        setState({
          stat_date: dt.toLocaleDateString("en-AU", options),
          modified: true,
        });
      }
      setState({
        [name]: dt.toLocaleDateString("en-AU", options),
        modified: true,
      });
    } else {
      setState({
        [name]: null,
        modified: true,
      });
    }
    setState({ modified: true });
  }

  const handleCheckBoxChange = (event) => {
    let name = event.target.name;
    const updateObj = { [name]: event.target.checked };
    stateRef.current = { ...stateRef.current, ...updateObj };
    setState(
      {
        ...updateObj,
      },
      handleBlur
    );
    setState({ modified: true });
  };

  const handleRedeliver = async (event) => {
    var options = { year: "numeric", month: "long", day: "numeric" };
    const today = new Date();

    const delivery_date = new Date(stateRef.current.print_month);
    //If the delivery date is today do nothing
    if (!stateRef.current.print_month) {
      alert("Delivery date cannot be empty");
      return;
    } else {
      if (today.getDate() === delivery_date.getDate() && today.getMonth() === delivery_date.getMonth() && today.getFullYear() === delivery_date.getFullYear()) {
        alert("Delivery date cannot be today");
        return;
      } else if ((today.getDate() < delivery_date.getDate() && today.getMonth() === delivery_date.getMonth() && today.getFullYear() === delivery_date.getFullYear()) || (today.getMonth() < delivery_date.getMonth() && today.getFullYear() === delivery_date.getFullYear()) || today.getFullYear() < delivery_date.getFullYear()) {
        alert("Delivery date cannot be in the past");
        return;
      } else {
        const updateObj = { prev_delivery: stateRef.current.print_month, print_month: today.toLocaleDateString("en-AU", options), modified: true };
        stateRef.current = { ...stateRef.current, ...updateObj };
        setState(updateObj, handleBlur);
      }
    }
  };

  const handleRentChange = async (event) => {
    if (!event?.target) {
      return;
    }
    const col = event.target.name || event.target.id;
    const currencyFormatter = new Intl.NumberFormat("en-AU", {
      style: "currency",
      currency: "AUD",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });

    if (col === "tenant_area") {
      if (stateRef.current.tenant_area > 0) {
        if (stateRef.current.rent > 0) {
          const rent_per_annum = Math.round(stateRef.current.rent * stateRef.current.tenant_area);

          if (exceedsIntegerColumn(rent_per_annum)) {
            alert(`Rent per Annum would calculate to ${currencyFormatter.format(rent_per_annum)}, which is too large to be saved. Please check Area SQM and Rent per SQM.`);
            return;
          }

          const confirmed = stateRef.current.rent_per_annum ? window.confirm(`Is it OK to overwrite the current value of Rent Per Annum with ${currencyFormatter.format(rent_per_annum)}?`) : true;

          if (!confirmed) {
            return;
          } else {
            setState({ rent_per_annum });
            return true;
          }
        } else if (stateRef.current.rent_per_annum > 0) {
          const rent = Math.round(stateRef.current.rent_per_annum / stateRef.current.tenant_area);
          const confirmed = stateRef.current.rent ? window.confirm(`Is it OK to overwrite the current value of Rent Per SQM with ${currencyFormatter.format(rent)}?`) : true;

          if (!confirmed) {
            return;
          } else {
            setState({ rent });
            return true;
          }
        }
      } else {
        const rent = "";
        const confirmed = stateRef.current.rent ? window.confirm(`Is it OK to overwrite the current value of Rent Per SQM with ${currencyFormatter.format(rent)}?`) : false;

        if (!confirmed) {
          return;
        } else {
          setState({ rent });
          return true;
        }
      }
    }

    if (col === "rent") {
      if (stateRef.current.rent > 0) {
        if (stateRef.current.tenant_area > 0) {
          const rent_per_annum = Math.round(stateRef.current.rent * stateRef.current.tenant_area);
          if (exceedsIntegerColumn(rent_per_annum)) {
            alert(`Rent per Annum would calculate to ${currencyFormatter.format(rent_per_annum)}, which is too large to be saved. Please check Area SQM and Rent per SQM.`);
            return;
          }
          const confirmed = stateRef.current.rent_per_annum ? window.confirm(`Is it OK to overwrite the current value of Rent Per Annum with ${currencyFormatter.format(rent_per_annum)}?`) : true;

          if (!confirmed) {
            return;
          } else {
            setState({ rent_per_annum });
            return true;
          }
        } else if (stateRef.current.rent_per_annum > 0) {
          const tenant_area = Math.round(stateRef.current.rent_per_annum / stateRef.current.rent);
          const confirmed = stateRef.current.tenant_area ? window.confirm(`Is it OK to overwrite the current value of Area with ${tenant_area}?`) : true;

          if (!confirmed) {
            return;
          } else {
            setState({ tenant_area });
            return true;
          }
        }
      }
    }

    if (col === "rent_per_annum") {
      if (stateRef.current.rent_per_annum > 0) {
        if (stateRef.current.tenant_area > 0) {
          const rent = Math.round(stateRef.current.rent_per_annum / stateRef.current.tenant_area);
          const confirmed = stateRef.current.rent ? window.confirm(`Is it OK to overwrite the current value of Rent Per SQM with ${currencyFormatter.format(rent)}?`) : true;

          if (!confirmed) {
            return;
          } else {
            setState({ rent });
            return true;
          }
        } else if (stateRef.current.rent > 0) {
          const tenant_area = Math.round(stateRef.current.rent_per_annum / stateRef.current.rent);
          const confirmed = stateRef.current.tenant_area ? window.confirm(`Is it OK to overwrite the current value of Area with ${tenant_area}?`) : true;

          if (!confirmed) {
            return;
          } else {
            setState({ tenant_area });
            return true;
          }
        }
      }
    }
  }
  //rent_per_annum
  //rent

  const handleBlur = async (event) => {
    const fieldId = event?.target ? (event.target.name || event.target.id) : null;
    if (fieldId === "unit_number" && stateRef.current.unit_number) {
      alert("Please note: this is to be used only where the record relates to a strata unit. Suite or Level information should not be entered in Unit Number.");
    }
    if (stateRef.current.modified === true) {
      await handleRentChange(event);
      setState({ showAlert: false, last_edited_by: props.user });
      const lease = await syncroniseState();
      const validation = validateRelatedRecord(lease, "lease");
      if (validation[0] === true) {
        if (validation[1] !== "") {
          setState({ errorMessage: validation[1] });
          setState({ showAlert: true });
        }
        try {
          setState((state) => ({ modified: false }));
          const routeLeaseId = getRouteLeaseId();
          if (routeLeaseId === "new") {
            setState({ isLoading: true });
            setState({ lease: { ...lease, _cloned: false } });
          }

          const result = await saveLease(lease);
          setState({ isLoading: false });

          if (result.result === false) {
            // Surfaced in the dismissable error modal rather than window.alert, which blocks
            // the page and makes a long database error impossible to read or escape.
            setState({ errorMessage: result.error_message, showAlert: true });
          } else {
            if (routeLeaseId === "new") {
              setState((state) => ({ lease_id: result.id }), async () => {
                if (getRouteState()?.clone) {
                  await cloneLeaseParcels(null, result.id);
                  await cloneLeaseVolumeFolios(null, result.id);
                  await cloneLeaseIntegrations(null, result.id);
                }
                pushRoute("/slmleases/" + result.id);
              });
            } else {
              if (fieldId === "unit_number") {
                // Address matching
                getIntegrations();
                getTitleDetails();
                // togglePropertyIntegrationsModal();
              }

              if (fieldId === "lease_notes") {
                updateTitleDetailsString();
              }
            }
          }
        } catch (e) {
          setState({ errorMessage: e?.message || String(e), showAlert: true });
        }
      } else {
        setState({ errorMessage: validation[1] });
        setState({ showAlert: true });
      }
    }
  };

  const updateVendorFields = () => {
    if (stateRef.current.ownerLinks.filter((e) => e.type === "Lessor" && e.name !== "" && e.name !== null).length > 0) {
      let vendors = stateRef.current.ownerLinks.filter((e) => e.type === "Lessor" && e.name !== "" && e.name !== null).map((e) => (e.name || "").trimEnd());

      //dedupe vendors
      const vendorsSet = new Set(vendors);
      vendors = [...vendorsSet];
      const vendorsString = vendors.join("; ");

      stateRef.current = { ...stateRef.current, owner: vendorsString };
      setState({ owner: vendorsString, modified: true }, handleBlur);
    } else {
      if (stateRef.current.owner) {
        const confirmed = window.confirm("Do you want to clear the Lessor form field?");

        if (confirmed && stateRef.current.owner) {
          stateRef.current = { ...stateRef.current, owner: "" };
          setState({ owner: "", modified: true }, handleBlur);
        }
      }
    }

    if (stateRef.current.ownerLinks.filter((e) => e.type === "Lessee" && e.name !== "" && e.name !== null).length > 0) {
      let buyers = stateRef.current.ownerLinks.filter((e) => e.type === "Lessee" && e.name !== "" && e.name !== null).map((e) => (e.name || "").trimEnd());

      //dedupe vendors
      const buyersSet = new Set(buyers);
      buyers = [...buyersSet];
      const buyersString = buyers.join("; ");

      stateRef.current = { ...stateRef.current, lessee: buyersString };
      setState({ lessee: buyersString, modified: true }, handleBlur);
    } else {
      if (stateRef.current.lessee) {
        const confirmed = window.confirm("Do you want to clear the Lessee form field?");

        if (confirmed && stateRef.current.lessee) {
          stateRef.current = { ...stateRef.current, lessee: "" };
          setState({ lessee: "", modified: true }, handleBlur);
        }
      }
    }
  }

  const updateAgencyFields = (entityLinksOverride = null) => {
    const entityLinks = Array.isArray(entityLinksOverride) ? entityLinksOverride : stateRef.current.entityLinks;

    if (entityLinks.length > 0) {
      let agencies = entityLinks.filter((f) => f.name != null && f.name.trim() !== "").map((e) => e.name.trim());

      //dedupe agencies
      const agenciesSet = new Set(agencies);
      agencies = [...agenciesSet];
      const agenciesString = agencies.sort().slice(0, 2).join("; ");

      let agentString = "";
      if (agencies.length === 1) {
        let agents = entityLinks
          .filter((f) => f.agent_name !== "" && f.agent_name !== null)
          .map((e) => e.agent_name)
          .sort();
        //dedupe agencies
        const agentsSet = new Set(agents);
        agents = [...agentsSet];
        agentString = agents.join("; ");
      } else {
        for (let x = 0; x < 2; x++) {
          let agents = entityLinks
            .filter((e) => e.name?.trim() === agencies[x] && e.agent_name != null && e.agent_name.trim() !== "")
            .map((e) => e.agent_name)
            .sort();

          if (agents.length > 0) {
            if (agents[0] !== null && agents[0] !== " ") {
              agentString = (agentString + " " + agencies[x]).trim();
              //dedupe agencies
              const agentsSet = new Set(agents);
              agents = [...agentsSet];

              agentString = agentString + ": " + agents.slice(0, 2).join("; ") + ".";
            }
          }
        }
      }
      stateRef.current = { ...stateRef.current, agency: agenciesString, agent: agentString };
      setState({ agency: agenciesString, agent: agentString, modified: true }, handleBlur);
    } else {
      stateRef.current = { ...stateRef.current, agency: "", agent: "" };
      setState({ agency: "", agent: "", modified: true }, handleBlur);
    }
  }

  const handleDelete = async (event) => {
    event.preventDefault();

    const confirmed = window.confirm("Are you sure you want to delete this lease?");

    if (!confirmed) {
      return;
    } else {
      setState({ archived_date: new Date() }, () =>
        syncroniseState().then(async () => {
          const result = await saveLease(stateRef.current.lease);
          if (result.result === false) {
            alert(result.error_message);
          } else {
            pushRoute("/slmaddresses/" + (addressRecordId ?? stateRef.current.address_id));
          }
        })
      );
    }
  };

  const getTitleDetails = () => {
    try {
      const effectiveLeaseId = getEffectiveLeaseId();
      if (!effectiveLeaseId) {
        return;
      }

      apiGet(`/slmleases/${effectiveLeaseId}/parcels`, null).then((titleDetailsResponse) => {
        const titleDetails = Array.isArray(titleDetailsResponse)
          ? [...titleDetailsResponse]
          : Array.isArray(titleDetailsResponse?.items)
            ? [...titleDetailsResponse.items]
            : [];

        if (titleDetails) {
          setState((state) => ({ titleDetails }));
          updateTitleDetailsString();
        }
      });
    } catch (e) {
      console.warn("Error getting parcels:", e);
    }
  }

  const toggleTitleDetailsModal = async () => {
    setState(
      (prevState) => ({
        showTitleDetailsDialog: !prevState.showTitleDetailsDialog,
      }),
      () => {
        if (!stateRef.current.showTitleDetailsDialog && stateRef.current.titleDetailsSaved) {
          setState({ titleDetailsSaved: false });
          updateTitleDetailsString();
        }
      }
    );
  };

  const getVolumeFolios = (fromModal = false) => {
    try {
      const effectiveLeaseId = getEffectiveLeaseId();
      if (!effectiveLeaseId) {
        return;
      }

      apiGet(`/slmleases/${effectiveLeaseId}/volume_folios`, null).then((volumeFolios) => {
        if (fromModal) {
          let updatedVolumeFolios = [...stateRef.current.volumeFolios].map((uvf) => {
            const matchingVf = volumeFolios.find((vf) => vf.volume_folio_id === uvf.volume_folio_id);
            return matchingVf ? matchingVf : uvf;
          });
          setState({ volumeFolios: updatedVolumeFolios });
          return;
        }
        setState((state) => ({ volumeFolios }));
      });
    } catch {
      console.warn("Error getting volume folios");
    }
  }

  const toggleVolumeFoliosModal = async () => {
    setState(
      (prevState) => ({
        showVolumeFoliosDialog: !prevState.showVolumeFoliosDialog,
      }),
      () => {
        if (!stateRef.current.showVolumeFoliosDialog && stateRef.current.volumeFoliosSaved) {
          setState({ volumeFoliosSaved: false });
          updateTitleDetailsString();
        }
      }
    );
  };

  const getIntegrations = async () => {

    const effectiveLeaseId = getEffectiveLeaseId();
    if (!effectiveLeaseId) {
      return;
    }

    const response = await apiGet(`/slmleases/${effectiveLeaseId}/integrations`);

    setState({ integrations: response });

  }

  const togglePropertyIntegrationsModal = async () => {
    setShowPropertyIntegrationsModal((prev) => !prev);
  };

  const loadTitleDetailsRetry = () => {
    setTimeout(() => {
      getTitleDetails();
    }, 30000)
    setTimeout(() => {
      getTitleDetails();
    }, 60000)
    setTimeout(() => {
      getTitleDetails();
    }, 90000)
  }
  
  const saveIntegration = async (integration) => {
    integration.last_edited_date = new Date();
    integration.last_edited_by = props.user;

    loadTitleDetailsRetry();

    const effectiveLeaseId = getEffectiveLeaseId();
    if (!effectiveLeaseId) {
      return integration;
    }

    await apiPut(`/slmleases/${effectiveLeaseId}/integrations/${integration.property_integration_id}`, integration);

    return integration;
  }

  /**
   * Re-matches and updates integrations for all sales and leases of the related address.
   * @param {number} address_id - The id of the address.
   */
  const updateRelatedIntegrations = async (address_id) => {
    return await apiPut("/slmleases/integrations/related/new", address_id);
  }

  const acceptIntegration = (row, e) => {
    const updatedIntegration = {
      ...row.original,
      is_accepted: true,
      accept_reject_by: props.user,
    };

    saveIntegration(updatedIntegration);
    setState((prevState) => ({
      integrations: prevState.integrations.map((integration) =>
        integration.property_integration_id === updatedIntegration.property_integration_id ? updatedIntegration : integration
      ),
    }));
  }

  const rejectIntegration = (row, e) => {
    const updatedIntegration = {
      ...row.original,
      is_accepted: false,
      accept_reject_by: props.user,
    };

    saveIntegration(updatedIntegration);
    setState((prevState) => ({
      integrations: prevState.integrations.map((integration) =>
        integration.property_integration_id === updatedIntegration.property_integration_id ? updatedIntegration : integration
      ),
    }));
  }

  /**
   * Updates the integrations for this lease and all other leases and sales for the related address.
   */
  const updateIntegrations = async () => {
    const effectiveAddressId = addressRecordId ?? stateRef.current.address_id;
    if (!effectiveAddressId) {
      setState({ errorMessage: "Address ID is missing. Save or reload the lease, then try Refresh Address Match again.", showAlert: true });
      return;
    }

    try {
      const response = await updateRelatedIntegrations(effectiveAddressId);
      if (!response) {
        console.warn("Refresh Address Match returned an empty response.");
      } else if (response.result !== true) {
        console.warn(response.error_message || "Refresh Address Match did not complete successfully.");
      }

      await getIntegrations();
    } catch (error) {
      console.error("Error refreshing integrations:", error);
      setState({ errorMessage: error?.message || "Error refreshing address match", showAlert: true });
    }
  }

  const updateTitleDetailsString = async () => {
    const effectiveLeaseId = getEffectiveLeaseId();
    if (!effectiveLeaseId) {
      return;
    }

    try {
      const response = await apiGet(`/slmleases/${effectiveLeaseId}`);
      setState({
        title_details: response?.title_details,
        lease_notes_computed: response?.lease_notes_computed,
      });
    } catch (error) {
      console.warn("Unable to refresh title details string:", error);
    }

    // const validVfs = [...stateRef.current.volumeFolios].filter(vf => (!!vf.volume && !!vf.folio) || !!vf.other);
    // const validTds = [...stateRef.current.titleDetails].filter(td => !!td.jurisdiction_id);
    // let newTitleDetailsStr = '';

    // if (validTds.length > 0) {
    //     const tdsString = validTds.map(td => td.jurisdiction_id).join(', ');
    //     newTitleDetailsStr += `RPD: ${tdsString||''}. `;
    // }

    // if (validVfs.length > 0) {
    //     const vfsString = validVfs.map(vf => {
    //         if (vf.volume && vf.folio) { return `V${vf.volume} F${vf.folio}` }
    //         return vf.other
    //     }).join(', ')
    //     newTitleDetailsStr += `Title Ref: ${vfsString||''}. `;
    // }

    // setState({ title_details: newTitleDetailsStr.trim() });

    // const lease = {...stateRef.current.lease};
    // lease.title_details = newTitleDetailsStr;
    // saveLease(lease)
  }

  const render = () => {
    const createId = createIdFactory;
    const leaseId = getEffectiveLeaseId();
    const isNewLeaseRoute = getRouteLeaseId() === "new";
    const addressId = addressRecordId;
    const suburb = suburbName;
    const postcode = postcodeValue;
    const currencyFormatter = new Intl.NumberFormat("en-AU", {
      style: "currency",
      currency: "AUD",
      minimumFractionDigits: 0,
      // maximumFractionDigits: 2
    });

    // const numberFormatter = new Intl.NumberFormat("en-AU", {
    //   style: "decimal",
    //   minimumFractionDigits: 0,
    //   maximumFractionDigits: 0,
    // });
    return (
      <div className="Lease" id={createId("container")}>
        {state.isLoading && (
          <div className="outer-div">
            <div className="sweet-loading inner-div">
              <PacmanLoader
                css="display: block;
                            margin: 0 auto;
                             border-color: red"
                sizeUnit={"px"}
                size={20}
                color={"#e03c31"}
                loading={state.isLoading}
              />
            </div>
          </div>
        )}

        {props.isAuthenticated && !state.isLoading && (state.lease || isNewLeaseRoute) && (
          <Form id={createId("form")}>
            <Modal
              id={createId("error", "modal")}
              show={state.showAlert && leaseId ? true : false}
              onHide={(e) => {
                setState({ showAlert: !state.showAlert });
              }}
              centered
            >
              <Modal.Header closeButton>
                {" "}
                <Modal.Title>Uh Oh!</Modal.Title>
              </Modal.Header>
              <Modal.Body style={{ maxHeight: "60vh", overflowY: "auto" }}>
                {" "}
                <Alert variant="danger" style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                  {state.errorMessage}
                </Alert>{" "}
              </Modal.Body>
            </Modal>
            {state.showAlert && !leaseId && <Alert variant="danger">{state.errorMessage}</Alert>}

            <Row className="g-2 mb-2 align-items-start">
              <Col xs={12} lg={5}>
                <h6>
                  Lease Details - {state.lease_type} | {state.stat_date} |{state.lease_level || ""} {buildingName || ""} | {streetAddressFull || ""} {suburb || ""} {stateCode || ""} {postcode || ""}
                </h6>
              </Col>
              <Col xs={12} lg={3}>
                {state.idList.length > 1 && (
                  <SLMBrowsePager
                    idList={state.idList}
                    currentRecordId={getRouteLeaseId()}
                    onNavigate={navigateToBrowseLeaseRecord}
                    elementIds={{
                      previousButtonId: createId("nav", "previous", "button"),
                      nextButtonId: createId("nav", "next", "button"),
                      inputId: createId("nav", "record", "input"),
                    }}
                  />
                )}
              </Col>

              <Col xs={12} lg={4}>
                <Nav className="justify-content-start justify-content-lg-end flex-wrap gap-1">
                  <Nav.Item>
                    <Button
                      id={createId("action", "new", "button")}
                      variant="primary"
                      type="button"
                      size="sm"
                      className="slm-compact-action-btn"
                      onClick={() =>
                        pushRoute("/slmleases/new", {
                          address_id: addressId,
                          address_hard_sequence: addressHardSequence ?? state.address_hard_sequence,
                          building_name: buildingName,
                          floor_unit: floorUnit ?? state.floor_unit,
                          street_no_low: state.street_no_low,
                          street_no_high: state.street_no_high,
                          street_name: state.street_name,
                          extension: state.extension,
                          street_address_full: streetAddressFull ?? state.street_address_full,
                          suburb: suburb,
                          state_code: stateCode,
                          postcode: postcode,
                        })
                      }
                    >
                      New Lease
                    </Button>{" "}
                  </Nav.Item>
                  <Nav.Item>
                    <a href={`/slmaddresses/${addressId}`}>
                      <Button id={createId("action", "back-address", "button")} variant="primary" size="sm" type="button" className="slm-compact-action-btn">
                        Back to Address
                      </Button>
                    </a>{" "}
                  </Nav.Item>
                  <Nav.Item>
                    <Button id={createId("action", "delete", "button")} variant="danger" type="button" onClick={handleDelete} size="sm" className="slm-compact-action-btn">
                      Delete Lease
                    </Button>
                  </Nav.Item>
                </Nav>
              </Col>
            </Row>

            <Row id="detail" className="g-2">
              <SLMPropertyAddressPanel
                colProps={{ xs: 12, md: 6, xl: 3 }}
                topCardId="leasedetails"
                colinId={leaseId}
                pimsId={state.address_hard_sequence ?? state.hard_sequence}
                addressId={addressId}
                addressHardSequence={addressHardSequence}
                buildingName={buildingName}
                streetAddressFull={streetAddressFull}
                suburb={suburb}
                stateCode={stateCode}
                postcode={postcode}
                editAddressTo={{ pathname: `/slmaddresses/${addressId}`, state: { lease_id: leaseId } }}
                editAddressButtonId={createId("action", "edit-address", "button")}
                createId={createId}
                unitNumber={state.unit_number}
                unitNumberInputId={createId("field", "unit-number", "input")}
                onUnitNumberChange={handleChange}
                onUnitNumberBlur={handleBlur}
                onAddressMetaChange={handleChange}
                onAddressMetaBlur={handleBlur}
                titleDetails={state.title_details}
                onTitleDetailsChange={handleChange}
                onCoreLogicEdit={togglePropertyIntegrationsModal}
                onCoreLogicRefresh={updateIntegrations}
                onCoreLogicRefreshTimeout={getIntegrations}
                coreLogicRefreshTimeout={30000}
                coreLogicEditButtonId={createId("action", "edit-integrations", "button")}
                coreLogicRefreshButtonId={createId("action", "refresh-address-match", "button")}
                renderCoreLogicContent={() => (
                  <>
                    <SLMPropertyIntegrationsList
                      filter={{ leaseid: leaseId }}
                      isAuthenticated={props.isAuthenticated}
                      controlType="list"
                      data={state.integrations}
                      updateTableState={updateTableState}
                      saveRecord={saveRecord}
                      deleteRecord={deleteRecord}
                      acceptIntegration={acceptIntegration}
                      rejectIntegration={rejectIntegration}
                      ctx="slmlease"
                    />
                    {showPropertyIntegrationsModal && (
                      <SLMPropertyIntegrationsModal
                        show={showPropertyIntegrationsModal}
                        onClose={togglePropertyIntegrationsModal}
                        filter={{ leaseid: leaseId }}
                        isAuthenticated={props.isAuthenticated}
                        user={props.user}
                        updateTableState={updateTableState}
                        saveForm={state.saveForm}
                        data={state.integrations}
                        saveRecord={saveRecord}
                        deleteRecord={deleteRecord}
                        validateRelatedRecord={validateRelatedRecord}
                        acceptIntegration={acceptIntegration}
                        rejectIntegration={rejectIntegration}
                        ctx="slmlease"
                      />
                    )}
                  </>
                )}
                renderParcelsSection={() => (
                  <Form.Group as={Row} controlId="parcels">
                    <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                      Parcels
                      <br />
                      (Top 3 - click Edit to view all)
                    </Form.Label>
                    <Col>
                      <Button onClick={toggleTitleDetailsModal} className="slm-compact-action-btn" size="m" variant="secondary" type="button" disabled={state.head_record_property_id ? true : false}>
                        Edit
                      </Button>
                      <SLMTitleDetailsList
                        filter={{ leaseid: leaseId }}
                        isAuthenticated={props.isAuthenticated}
                        controlType="list"
                        data={state.titleDetails}
                        dataFetch={getTitleDetails}
                        updateTableState={updateTableState}
                        saveRecord={saveRecord}
                        context="slmlease"
                        stateCode={stateCode || deriveStateCodeFromPostcode(postcodeValue)}
                        listAmount="3"
                      />

                      {state.showTitleDetailsDialog && <SLMTitleDetailsModal show={state.showTitleDetailsDialog} onClose={toggleTitleDetailsModal} filter={{ leaseid: leaseId }} isAuthenticated={props.isAuthenticated} toggleTitleDetailsModal={toggleTitleDetailsModal} user={props.user} data={state.titleDetails} dataFetch={getTitleDetails} updateTableState={updateTableState} saveRecord={saveRecord} deleteRecord={deleteRecord} validateRelatedRecord={validateRelatedRecord} context="slmlease" stateCode={stateCode || deriveStateCodeFromPostcode(postcodeValue)} />}
                    </Col>
                  </Form.Group>
                )}
                renderVolumeFoliosSection={() => (
                  <Form.Group as={Row} controlId="volume_folios">
                    <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                      Volume Folios
                      <br />
                      (Top 3 - click Edit to view all)
                    </Form.Label>
                    <Col>
                      <Button onClick={toggleVolumeFoliosModal} className="slm-compact-action-btn" size="m" variant="secondary" type="button" disabled={state.head_record_property_id ? true : false}>
                        Edit
                      </Button>
                      <SLMVolumeFoliosList filter={{ leaseid: leaseId }} isAuthenticated={props.isAuthenticated} controlType="list" data={state.volumeFolios} dataFetch={getVolumeFolios} updateTableState={updateTableState} saveRecord={saveRecord} deleteRecord={deleteRecord} context="slmlease" listAmount="3" />

                      {state.showVolumeFoliosDialog && <SLMVolumeFoliosModal show={state.showVolumeFoliosDialog} onClose={toggleVolumeFoliosModal} filter={{ leaseid: leaseId }} isAuthenticated={props.isAuthenticated} toggleVolumeFoliosModal={toggleVolumeFoliosModal} user={props.user} data={state.volumeFolios} dataFetch={getVolumeFolios} updateTableState={updateTableState} saveRecord={saveRecord} deleteRecord={deleteRecord} validateRelatedRecord={validateRelatedRecord} context="slmlease" />}
                    </Col>
                  </Form.Group>
                )}
              />

              <Col xs={12} md={6} xl={3}>
                <SLMReferencesPanel
                  referenceOptions={props.sourcecategoryOptions}
                  selectedSourceCategories1={state.selectedSourceCategories1}
                  selectedSourceCategories2={state.selectedSourceCategories2}
                  selectedSourceCategories3={state.selectedSourceCategories3}
                  sourceDate1={state.source_date_1}
                  sourceDate2={state.source_date_2}
                  sourceDate3={state.source_date_3}
                  sourcePage1={state.source_page_1}
                  sourcePage2={state.source_page_2}
                  sourcePage3={state.source_page_3}
                  onSource1Change={handleSource1Change}
                  onSource2Change={handleSource2Change}
                  onSource3Change={handleSource3Change}
                  onDateChange={handleDateChange}
                  onPageChange={handleNonNegativeNumberChange}
                  onBlur={handleBlur}
                  createId={createId}
                />

                <SLMSpaceInformationPanel
                  slmLookups={props.slmlookups}
                  selectedLeaseStatusCategories={state.selectedLeaseStatusCategories}
                  selectedBroadSpaceUseCategories={state.selectedBroadSpaceUseCategories}
                  selectedSpaceUseCategories={state.selectedSpaceUseCategories}
                  selectedLeaseMethodCategories={state.selectedLeaseMethodCategories}
                  selectedLevelCategories={state.selectedLevelCategories}
                  selectedCarSpaceCategories={state.selectedCarSpaceCategories}
                  selectedQualityTypeCategories={state.selectedQualityTypeCategories}
                  leaseStatusOptions={props.leasestatuscategoryOptions}
                  broadSpaceUseOptions={props.broadspaceusecategoryOptions}
                  detailedSpaceUseOptions={props.spaceusecategoryOptions}
                  leaseMethodOptions={props.leasemethodcategoryOptions}
                  levelOptions={props.leaselevelcategoryOptions}
                  carSpaceOptions={props.carspacecategoryOptions}
                  qualityTypeOptions={props.qualitytypecategoryOptions}
                  broadSpaceUseId={state.broad_space_use_id}
                  tenantArea={state.tenant_area}
                  leaseLevel={state.lease_level}
                  cars={state.cars}
                  leaseNotes={state.lease_notes}
                  leaseNotesComputed={state.lease_notes_computed}
                  noteData={state.note_data}
                  printMonth={state.print_month}
                  onStatusChange={handleStatusChange}
                  onBroadSpaceUseChange={handleBroadSpaceUseChange}
                  onSpaceUseChange={handleSpaceUseChange}
                  onLeaseMethodChange={handleLeaseMethodChange}
                  onLevelCategoryChange={handleLevelCategoryChange}
                  onCarSpaceChange={handleCarSpaceChange}
                  onQualityTypeChange={handleQualityTypeChange}
                  onNumberChange={handleNumberChange}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  createId={createId}
                  goLiveDate={goLive}
                />
              </Col>

              <Col xs={12} md={6} xl={3}>
                <SLMLeaseInformationPanel
                  slmLookups={props.slmlookups}
                  state={state}
                  createId={createId}
                  currencyFormatter={currencyFormatter}
                  reviewBasisOptions={props.leaselreviewbasiscategoryOptions}
                  rentPerAnnumBasisOptions={props.rentperannumbasiscategoryOptions}
                  rentBasisOptions={props.rentpersqmbasiscategoryOptions}
                  outgoingsBasisOptions={props.leaseoutgoingscategoryOptions}
                  onDateChange={handleDateChange}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  onNumberChange={handleNumberChange}
                  onCheckBoxChange={handleCheckBoxChange}
                  onReviewBasisCategoryChange={handleReviewBasisCategoryChange}
                  onRentPerAnnumBasisCategoryChange={handleRentPerAnnumBasisCategoryChange}
                  onRentBasisCategoryChange={handleRentBasisCategoryChange}
                  onOutgoingsCategoryChange={handleOutgoingsCategoryChange}
                  onMoneyChange={handleMoneyChange}
                />
              </Col>

              <Col xs={12} md={6} xl={3}>
                <SLMRecordDeliverPanel state={state} createId={createId} onRedeliver={handleRedeliver} onDateChange={handleDateChange} onBlur={handleBlur} onCheckBoxChange={handleCheckBoxChange} />

                <SLMAgentAgencyPanel
                  state={state}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  isAuthenticated={props.isAuthenticated}
                  updateTableState={updateTableState}
                  saveRecord={saveRecord}
                  deleteRecord={deleteRecord}
                  sale_id={null}
                  lease_id={leaseId}
                  user={props.user}
                  state_code={stateCode}
                  validateRelatedRecord={validateRelatedRecord}
                  getAgencies={getAgencies}
                  getAgents={getAgents}
                  getEntityLinks={getEntityLinks}
                  updateAgencyFields={updateAgencyFields}
                />

                <SLMOwnerPartyPanel
                  title="Lessee/Lessor"
                  state={state}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  primaryRole={{ field: "lessee", label: "Lessee", linkType: "Lessee" }}
                  secondaryRole={{ field: "owner", label: "Lessor", linkType: "Lessor" }}
                  isAuthenticated={props.isAuthenticated}
                  updateTableState={updateTableState}
                  saveRecord={saveRecord}
                  deleteRecord={deleteRecord}
                  sale_id={null}
                  lease_id={leaseId}
                  user={props.user}
                  state_code={stateCode}
                  validateRelatedRecord={validateRelatedRecord}
                  getOwners={getOwners}
                  getContacts={getContacts}
                  getOwnerLinks={getOwnerLinks}
                  updateVendorFields={updateVendorFields}
                  minimalPagination
                />

                <SLMHistoryPanel state={state} createId={createId} />
              </Col>
            </Row>
          </Form>
        )}
      </div>
    );
  }

  return render();
}



